import React, { Component, Fragment } from 'react'
import { Button, Form, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEraser, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import './ProductList.css'

class Product extends Component {
  getSubcategoryDisabled = () => {
    return this.props.selectedLossCode ? true : false
  }

  renderUpdateButton = () => {
    const {
      brand,
      handleUpdateProduct,
      loading,
      model,
      productPurchaseDate,
      subCategory,
      selectedProduct,
      serial,
      category,
      purchasePrice,
    } = this.props

    if (!selectedProduct) return null
    let hasDifference =
      (selectedProduct.mfg?.toUpperCase() !== brand?.toUpperCase() && brand?.length > 0) ||
      (selectedProduct.modelNumber?.toUpperCase() !== model?.toUpperCase() && model?.length > 0) ||
      (selectedProduct.serial?.toUpperCase() !== serial?.toUpperCase() && serial?.length > 0) ||
      moment(selectedProduct.productPurchaseDate).format('MM/DD/YYYY') !== productPurchaseDate ||
      (selectedProduct.category?.toUpperCase().trim() !== category?.toUpperCase().trim() &&
        category?.length > 0) ||
      (selectedProduct.subCategory !== subCategory && subCategory?.length > 0) ||
      (selectedProduct?.purchasePrice !== purchasePrice && purchasePrice?.length > 0)
    const buttonJSX = (
      <Button
        size='md'
        className='RoundedButton'
        onClick={() => handleUpdateProduct()}
        variant='outline-info'
        disabled={!hasDifference || loading}
      >
        <FontAwesomeIcon icon={faPencilAlt} />
        <span className='ps-1'>Update</span>
      </Button>
    )

    return buttonJSX
  }

  renderResetButton = () => {
    const { brand, handleResetProduct, loading, model, subCategory, selectedProduct, serial } =
      this.props

    let hasDifference =
      (selectedProduct.mfg.toUpperCase() !== brand.toUpperCase() && brand.length > 0) ||
      (selectedProduct.modelNumber.toUpperCase() !== model.toUpperCase() && model.length > 0) ||
      (selectedProduct.serial.toUpperCase() !== serial.toUpperCase() && serial.length > 0) ||
      (selectedProduct.subCategory !== subCategory && subCategory.length > 0)

    return (
      <Button
        size='md'
        className='RoundedButton'
        variant='outline-info'
        onClick={() => handleResetProduct()}
        disabled={!hasDifference || loading}
      >
        <FontAwesomeIcon icon={faEraser} />
        <span className='ps-1'>Reset</span>
      </Button>
    )
  }

  render() {
    const {
      brand,
      handleInputChange,
      isBrandValid,
      isBrandValidated,
      isModelValid,
      isModelValidated,
      isSubcategoryValid,
      isSubcategoryValidated,
      isSerialValid,
      isSerialValidated,
      manufacturers,
      model,
      subcategories,
      subCategory,
      productPurchaseDate,
      purchasePrice,
      handleProductPurchaseDate,
      serial,
      productPurchasePrice,
      isProductPurchasePriceValidated,
      isProductPurchasePriceValid,
    } = this.props

    const { category, industries } = this.props

    const selectedIndustry = industries?.find((ind) => ind.industryName === category)

    const selectedIndustryCode = selectedIndustry?.industryCode

    let filteredSubcategories = subcategories || []

    if (selectedIndustryCode) {
      filteredSubcategories = subcategories.filter((sub) => sub.catCode === selectedIndustryCode)
    }

    const isSelectedPresent = filteredSubcategories.some(
      (sub) => sub.subCatDescription.toUpperCase() === subCategory?.toUpperCase(),
    )

    if (!isSelectedPresent && subCategory) {
      const existing = subcategories.find(
        (sub) =>
          sub.subCatDescription?.toUpperCase().trim() === subCategory?.toUpperCase().trim() ||
          sub.subCatCode?.toUpperCase().trim() === subCategory?.toUpperCase().trim(),
      )

      if (existing) {
        filteredSubcategories = [existing, ...filteredSubcategories]
      }
    }
    let normalizedSubCategory = subCategory || ''

    if (subCategory && subcategories?.length > 0) {
      const match = subcategories.find(
        (sub) =>
          sub.subCatCode?.toUpperCase().trim() === subCategory?.toUpperCase().trim() ||
          sub.subCatDescription?.toUpperCase().trim() === subCategory?.toUpperCase().trim(),
      )

      if (match) {
        normalizedSubCategory = match.subCatDescription.toUpperCase()
      }
    }
    return (
      <Fragment>
        <small>
          <b>Note: </b>Product details cannot be updated after a claim is made on the product.
        </small>
        <Table responsive>
          <thead>
            <tr>
              <th>Manufacturer</th>
              <th>Industry</th>
              <th>Subcategory</th>
              <th>Model Number</th>
              <th>Serial</th>
              <th>Purchase Date</th>
              <th>Purchase Price</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ cursor: 'initial' }}>
              <td>
                <Form.Control
                  className={!isBrandValidated ? null : isBrandValid ? 'is-valid' : 'is-invalid'}
                  autoComplete='off'
                  as='select'
                  id='brand'
                  size='sm'
                  onChange={(event) => {
                    handleInputChange(event)
                  }}
                  value={brand}
                >
                  <option key='' value=''>
                    Select manufacturer...
                  </option>
                  {manufacturers.map((mfg) => (
                    <option key={mfg.brand} value={mfg.brand.toUpperCase()}>
                      {mfg.brand.toUpperCase()}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                  Please select a manufacturer.
                </Form.Control.Feedback>
              </td>
              <td>
                <Form.Control
                  as='select'
                  size='sm'
                  id='category'
                  className={
                    !this.props.isCategoryValidated
                      ? null
                      : this.props.isCategoryValid
                      ? 'is-valid'
                      : 'is-invalid'
                  }
                  value={category || ''}
                  onChange={(event) => handleInputChange(event)}
                >
                  <option value=''>Select industry...</option>

                  {this.props.industries
                    ?.sort((a, b) => a.industryName.localeCompare(b.industryName))
                    .map((industry) => (
                      <option key={industry.industryCode} value={industry.industryName}>
                        {industry.industryName}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                  Please select an industry.
                </Form.Control.Feedback>
              </td>
              <td>
                <Form.Control
                  className={
                    !isSubcategoryValidated ? null : isSubcategoryValid ? 'is-valid' : 'is-invalid'
                  }
                  autoComplete='off'
                  id='subCategory'
                  as='select'
                  size='sm'
                  onChange={(event) => {
                    handleInputChange(event)
                  }}
                  value={normalizedSubCategory}
                  // disabled={this.getSubcategoryDisabled()}
                >
                  <option key='' value=''>
                    Select subcategory...
                  </option>
                  {filteredSubcategories
                    ?.sort((a, b) => a.subCatDescription.localeCompare(b.subCatDescription))
                    .map((subcategory) => (
                      <option
                        key={`${subcategory.subCatCode}${subcategory.subCatDescription}`}
                        value={subcategory.subCatDescription.toUpperCase()}
                      >
                        {subcategory.subCatDescription.toUpperCase()}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                  Please select a subcategory.
                </Form.Control.Feedback>
              </td>
              <td>
                <Form.Control
                  className={!isModelValidated ? null : isModelValid ? 'is-valid' : 'is-invalid'}
                  id='model'
                  autoComplete='off'
                  type='text'
                  placeholder='model'
                  value={model}
                  size='sm'
                  onChange={(event) => {
                    handleInputChange(event)
                  }}
                />
                <Form.Control.Feedback type='invalid'>
                  Please provide the model number.
                </Form.Control.Feedback>
              </td>
              <td>
                <Form.Control
                  className={!isSerialValidated ? null : isSerialValid ? 'is-valid' : 'is-invalid'}
                  autoComplete='off'
                  id='serial'
                  type='text'
                  placeholder='serial'
                  value={serial}
                  size='sm'
                  onChange={(event) => {
                    handleInputChange(event)
                  }}
                />
                <Form.Control.Feedback type='invalid'>
                  Please provide a serial.
                </Form.Control.Feedback>
              </td>
              <td>
                <DatePicker
                  as={Form.Control}
                  selected={new Date()}
                  onSelect={(date) => handleProductPurchaseDate(date)}
                  value={productPurchaseDate}
                  maxDate={new Date()}
                  disabledKeyboardNavigation
                  className='purchaseDate'
                  aria-describedby='purchaseDateHelpBlock'
                />
              </td>
              <td>
                <Form.Control
                  className={
                    !isProductPurchasePriceValidated
                      ? null
                      : isProductPurchasePriceValid
                      ? 'is-valid'
                      : 'is-invalid'
                  }
                  autoComplete='off'
                  id='purchasePrice'
                  type='number'
                  placeholder='purchasePrice'
                  value={purchasePrice}
                  size='sm'
                  onChange={(event) => {
                    handleInputChange(event)
                  }}
                />
                <Form.Control.Feedback type='invalid'>
                  Please provide a purchase price.
                </Form.Control.Feedback>
              </td>
              <td>{this.renderResetButton()}</td>
              <td>{this.renderUpdateButton()}</td>
            </tr>
          </tbody>
        </Table>
      </Fragment>
    )
  }
}

export default Product
